import { render, staticRenderFns } from "./AppStandalone.vue?vue&type=template&id=0a59b99a&"
import script from "./AppStandalone.vue?vue&type=script&lang=js&"
export * from "./AppStandalone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports